import { EHhActionTypes } from '../../actions/cpa';
import { ICpa as ICpaState } from '../../types/cpa';
import { TReduxActions } from '../../types/redux';

const INITIAL_STATE: ICpaState = {
  hhQueryParams: { siteId: '', clickId: '' },
  isCPALanding: false,
  hhConversionId: '',
  cityAds: null,
};

export function cpaReducer(state: ICpaState = INITIAL_STATE, action: TReduxActions) {
  switch (action.type) {
    case EHhActionTypes.SetHhConversionId:
      return {
        ...state,
        hhConversionId: action.payload.hhConversionId,
      };

    default:
      return state;
  }
}
